import { Collapse } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import Monthly from "./Monthly";
import Progress from "./Progress";

const IncomeStatement = () => {
  const { t } = useTranslation();

  const items = [
    {
      key: 1,
      label: t("projectsManagement.incomeStatement.monthly"),
      className: "mb-1em",
      children: <Monthly />,
    },
    {
      key: 2,
      label: t("projectsManagement.incomeStatement.progress"),
      className: "mb-1em",
      children: <Progress />,
    },
  ];

  return (
    <>
      <Collapse items={items} className="mb-1em" />
    </>
  );
};

export default IncomeStatement;
